import React, { Component } from "react"
import RoomStatusList from "../RoomStatusList"
import RoomStatusListBsr from "../RoomStatusListBsr"
import Search from "../Search"
import PropTypes from "prop-types"
import CSVButton from "@swipesense/csv-button"
import TableFooter from "../TableFooter"
import {
  noRNDetected,
  noVisitsDetected,
} from "../../helpers/sharedHelperFunctions"
import "./RoomStatusListWithControls.scss"
import momentPropTypes from "react-moment-proptypes"
import ExcludedAreas from "../ExcludedAreas"
import moment from "moment"
import Loading from "../Loading"
import BsrComplianceToggleWithStore from "../BsrComplianceToggle/BsrComplianceToggleWithStore"

// Only exporting for purposes of the testing suite, no other use in code
class RoomStatusListWithControls extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
      excludedAreasModalOpen: false,
    }
  }

  componentDidMount() {
    // table-wrapper is created at render time, but we need its fully rendered height to apply our footer class.
    // Set it here so the footer renders only after the wrapper renders.
    if (this.tableWrapper) this.setState({ tableWrapper: this.tableWrapper })
  }

  handleSearchChange = e => {
    this.setState({ searchTerm: e.target.value })
  }

  filterData = unfilteredData => {
    let nurseResults = [],
      nurseAsstResults = [],
      roomResults = []

    nurseResults = unfilteredData.filter(row => {
      const field =
        row.primaryUser &&
        row.primaryUser.firstName + " " + row.primaryUser.lastName
      return (
        field &&
        field.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1
      )
    })

    nurseAsstResults = unfilteredData.filter(row => {
      const field =
        row.secondaryUser &&
        row.secondaryUser.firstName + " " + row.secondaryUser.lastName
      return (
        field &&
        field.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1
      )
    })

    roomResults = unfilteredData.filter(row => {
      const field = row.location && row.location.name
      return (
        field &&
        field.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1
      )
    })

    // Create Set to remove duplicates
    const combinedResultSet = new Set(
      nurseResults.concat(nurseAsstResults).concat(roomResults)
    )

    return Array.from(combinedResultSet)
  }

  csvFilename = () =>
    `${this.props.entityName.replace(/ /g, "_").toLowerCase()}_compliance.csv`

  csvHeaders = () => {
    let headers = [
      "location",
      "shift start",
      "shift end",
      "nurse",
      "nurse assistant",
    ]
    /* istanbul ignore else */
    if (this.props.bsrCompliance) {
      headers = headers.concat([
        "BSR shift start duration (seconds)",
        "BSR shift end duration (seconds)",
        "BSR Compliance Start Shift",
        "BSR Compliance End Shift",
      ])
    } else if (!this.props.bsrCompliance) {
      headers = headers.concat(["compliance"])
    }
    return headers
  }

  renderCSVCompliance = shift => {
    if (noRNDetected(shift) || noVisitsDetected(shift)) {
      return ""
    } else {
      return Math.round(shift.compliancePercentage).toString()
    }
  }

  renderCSVName = user => {
    return user && user.firstName + " " + user.lastName
  }

  bsrStartingShiftDuration = data => {
    /* istanbul ignore else */
    if (data.beginningShiftChange && data.beginningShiftChange.duration) {
      return data.beginningShiftChange.duration
    }
  }

  bsrEndingShiftDuration = data => {
    /* istanbul ignore else */
    if (data.endingShiftChange && data.endingShiftChange.duration) {
      return data.endingShiftChange.duration
    }
  }

  bsrComplianceMet = shiftChange => {
    /* istanbul ignore next */
    if (!shiftChange) return "False"
    if (shiftChange.complianceMet) {
      return "True"
    } else {
      return "False"
    }
  }

  mapData = data => {
    const dataObj = {
      location: data.location.name,
      nurse: this.renderCSVName(data.primaryUser),
      "nurse assistant": this.renderCSVName(data.secondaryUser),
      "shift start": moment(data.startsAt).format("M/D/YYYY ha"),
      "shift end": moment(data.endsAt).format("M/D/YYYY ha"),
    }

    this.beginningShiftChange = data => {
      if (data.beginningShiftChange && data.beginningShiftChange.duration) {
        dataObj[
          "BSR shift start duration (seconds)"
        ] = this.bsrStartingShiftDuration(data)
        dataObj["BSR Compliance Start Shift"] = this.bsrComplianceMet(
          data.beginningShiftChange
        )
      } else {
        dataObj["BSR Compliance Start Shift"] = "False"
      }
    }

    this.endingShiftChange = data => {
      if (data.endingShiftChange && data.endingShiftChange.duration) {
        dataObj[
          "BSR shift end duration (seconds)"
        ] = this.bsrEndingShiftDuration(data)
        dataObj["BSR Compliance End Shift"] = this.bsrComplianceMet(
          data.endingShiftChange
        )
      } else {
        dataObj["BSR Compliance End Shift"] = "False"
      }
    }

    if (this.props.bsrCompliance) {
      this.beginningShiftChange(data)
      this.endingShiftChange(data)
      /* istanbul ignore if */
    } else {
      dataObj["compliance"] = this.renderCSVCompliance(data)
    }
    return dataObj
  }

  render() {
    if (!this.props.loading) {
      const data = this.filterData(this.props.shiftAssignments).map(row => {
        return {
          ...row,
          startsAt: moment.parseZone(row.startsAt),
          endsAt: moment.parseZone(row.endsAt),
        }
      })
      return (
        <div className="RoomStatusListWithControls">
          <div className="filter-and-search">
            <BsrComplianceToggleWithStore />
            <div className="search-and-download">
              <Search
                value={this.state.searchTerm}
                handleChange={this.handleSearchChange}
              />
              <CSVButton
                filename={this.csvFilename()}
                headers={this.csvHeaders()}
                data={data}
                mapData={this.mapData}
              />
            </div>
          </div>
          <div className="table-wrapper" ref={el => (this.tableWrapper = el)}>
            {this.props.bsrCompliance && (
              <RoomStatusListBsr
                shiftAssignments={data}
                loading={this.props.loading}
                entityType={this.props.entityType}
              />
            )}
            {!this.props.bsrCompliance && (
              <RoomStatusList
                shiftAssignments={data}
                loading={this.props.loading}
                entityType={this.props.entityType}
              />
            )}
          </div>
          <TableFooter
            dataCount={data.length}
            wrapperHeight={
              this.state.tableWrapper &&
              this.state.tableWrapper.getClientRects()[0].height
            }
            rowHeight={36}
          >
            {["locations", "units"].includes(this.props.entityType) && (
              <span
                className="excluded-areas footer-link"
                onClick={() =>
                  this.setState({
                    excludedAreasModalOpen: true,
                  })
                }
              >
                <span>Excluded Areas</span>
              </span>
            )}
          </TableFooter>
          <ExcludedAreas
            modalOpen={this.state.excludedAreasModalOpen}
            onClose={() => this.setState({ excludedAreasModalOpen: false })}
          />
        </div>
      )
    } else {
      return <Loading />
    }
  }
}

RoomStatusListWithControls.propTypes = {
  entityName: PropTypes.string.isRequired,
  entityId: PropTypes.string.isRequired,
  shiftAssignments: RoomStatusList.propTypes.shiftAssignments,
  onlyComplianceData: PropTypes.bool,
  updatePath: PropTypes.func,
  loading: PropTypes.bool,
  entityType: PropTypes.string,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  bsrCompliance: PropTypes.bool,
}

RoomStatusListWithControls.defaultProps = {
  entityName: "swipesense",
}

export default RoomStatusListWithControls
